import React, { useMemo } from 'react';
import { useDisclosure } from '@chakra-ui/react';
import {
    SnippetOverlayContainerProps,
    SnippetOverlayViewProps,
} from './snippetOverlayProps';
import { ReportingContainerBaseConfig } from '../../../base';
import { SnippetOverlayController } from './snippetOverlayInterface';
import { useSearchParams } from 'react-router-dom';
import { z } from 'zod';

export function createSnippetOverlayContainer(
    config: ReportingContainerBaseConfig & {
        keys: {
            snippetUrParam: string;
        };
    },
    controller: SnippetOverlayController,
    View: React.FC<SnippetOverlayViewProps>
): React.FC<SnippetOverlayContainerProps> {
    const {
        context: { useContext },
        kernel: {
            infra: {
                optionParser: { useOptions },
            },
        },
    } = config;

    const UrlParamSchema = z.object({
        [config.keys.snippetUrParam]: z.string().optional(),
    });

    return ({ ...containerProps }) => {
        const { [config.keys.snippetUrParam]: snippetId } = useOptions(UrlParamSchema);
        const context = useContext();
        const [_searchParams, setSearchParams] = useSearchParams();
        const props = controller.useProps(
            context,
            {},
            {
                disclosure: useDisclosure({
                    isOpen: !!snippetId,
                    onClose() {
                        setSearchParams((prev) => {
                            prev.delete(config.keys.snippetUrParam);
                            return prev;
                        });
                    },
                }),
                snippet: snippetId
                    ? {
                          id: snippetId,
                      }
                    : null,
            }
        );
        return <View {...props} />;
    };
}
